import { Injectable } from '@angular/core';
import { Template } from './model/template-settings.interface';
import { DataService } from 'src/app/Services/Data/data.service';
import { Salesforce } from 'src/app/Services/Data/data.model';

@Injectable()
export class TemplateSettingsService {
  // Cross Component Variables
  currentTemplate: any;
  userSFData: Salesforce;
  templateSettingList: any;
  templateSuggestionList: any = [];
  salesforceObjectList: any = [];
  salesforce_session_data: any;
  error_messages: any = [];
  isUserLoggedInSN = null;

  constructor(private dataService: DataService) {}

  setIsUserLoggedIn(status: boolean) {
    this.isUserLoggedInSN = status;
  }

  isUserLoggedInSignNow() {
    return this.isUserLoggedInSN;
  }

  async getSFData() {
    return await this.dataService.apiGetCall('/api/salesforce_session_data').toPromise();
  }

  async getUserSfData() {
    this.userSFData = this.dataService.getSalesforceData();
    return this.userSFData;
  }

  getTemplateSettingList() {
    return this.templateSettingList;
  }

  setTemplateSuggestionList(templateSuggestionList) {
    if (templateSuggestionList && templateSuggestionList.length) {
      this.templateSuggestionList = templateSuggestionList;
    }
  }
  getTemplateSuggestionList() {
    return this.templateSuggestionList;
  }

  setSalesforceObjectList(salesforceObjectList) {
    if (salesforceObjectList && salesforceObjectList.length) {
      this.salesforceObjectList = salesforceObjectList;
    }
  }
  getSalesforceObjectList() {
    return this.salesforceObjectList;
  }

  getAllTemplateSettings() {
    const params = {
      sf_token: this.userSFData.sf_token,
      instance_url: this.userSFData.instance_url
    };
    return this.dataService.apiGetCall('/api/get_all_templates_settings_names_ids', { params });
  }

  getTemplateSettings(i: any, listItem: any) {
    this.currentTemplate = listItem;
    return this.dataService.apiGetCall('/api/retrieve_template_setting', { params: listItem });
  }

  updateTemplateSettings(data: any) {
    return this.dataService.apiPostCall('/api/edit_template_settings', { params: data });
  }

  createNewTemplate(data: Template): any {
    return this.dataService.apiPostCall('/api/createTemplateSetting', data);
  }

  getListRecordFields(type) {
    return this.dataService.apiGetCall('/api/get_list_type_fields', { params: { record_type: type } });
  }

  getRecordFieldsFromSalesforce() {
    return this.dataService.apiGetCall('/api/get_list_object');
  }

  deleteTemplateSettings(templateId) {
    return this.dataService.apiPostCall('/api/delete_template_setting', { params: templateId });
  }

  updateError(msg: string) {
    this.error_messages = [];
    this.error_messages.push(msg);
  }

  setTemplate(template) {
    this.currentTemplate = template;
  }
  resetTemplate() {
    this.currentTemplate = null;
  }
}
